<template>
  <div :class="typeClass" class="notification" role="alert">
    <template v-if="te(`errors.${notification.message}`)">
      <div class="notification__code">
        {{ $t(`errors.${notification.message}.title`) }}
      </div>
      <div class="notification__message">
        {{ $t(`errors.${notification.message}.message`) }}
      </div>
    </template>
    <template v-else>
      <div class="notification__code">
        {{ $t(`errors.fallback.title`) }}
      </div>
      <div class="notification__message">
        {{ $t(`errors.fallback.message`) }}
      </div>
    </template>
    <button
      type="button"
      class="notification__close"
      data-dismiss="alert"
      aria-label="Close"
      @click="removeNotification(notification)"
    >
      <div>&times;</div>
    </button>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

export default defineComponent({
  props: {
    notification: {
      type: Object,
      validator(value) {
        // The value must match one of these strings
        return ['success', 'warning', 'danger'].includes(value.type);
      },
    },
  },

  setup(props) {
    const { te } = useI18n();
    const store = useStore();

    const typeClass = computed(() => {
      return `notification--${props.notification.type}`;
    });

    const removeNotification = (notification) => {
      store.dispatch('notification/removeNotification', notification);
    };

    return {
      te,
      typeClass,
      removeNotification,
    };
  },
});
</script>
<style scoped lang="scss">
@import '@/scss/variables.scss';

.notification {
  width: 33.5rem;
  min-height: 5rem;
  box-shadow: 0px 0px 6px 2px rgba(147, 181, 191, 0.3);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: $notification-col;
  position: relative;
  z-index: $notification-z-index;

  &--warning {
    background-color: $allert-bgc;
  }

  &--success {
    background-color: $success-bgc;
  }

  &__close {
    width: 2.4rem;
    height: 2.4rem;
    font-size: 2.5rem;
    font-weight: 300;
    border-radius: 50%;
    border: 3px solid $notification-col;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 0.8rem;
    top: 0.8rem;

    & div {
      height: 100%;
      font-size: 25px;
      transform: translateY(-43%);
    }
  }

  &__message {
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.2rem;
    color: #fff;
  }

  &__code {
    font-weight: 700;
    font-size: 1.2rem;
  }
}
</style>

<style scoped lang="scss">
@import '@/scss/variables.scss';

.notification {
  width: 33.5rem;
  min-height: 5rem;
  box-shadow: 0px 0px 6px 2px rgba(147, 181, 191, 0.3);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: $notification-col;
  position: relative;
  z-index: $notification-z-index;

  &--warning {
    background-color: $allert-bgc;
  }

  &--success {
    background-color: $success-bgc;
  }

  &__close {
    width: 2.4rem;
    height: 2.4rem;
    font-size: 2.5rem;
    font-weight: 300;
    border-radius: 50%;
    border: 3px solid $notification-col;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 0.8rem;
    top: 0.8rem;

    & div {
      height: 100%;
      font-size: 25px;
      transform: translateY(-43%);
    }
  }

  &__message {
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.2rem;
  }

  &__code {
    font-weight: 700;
    font-size: 1.2rem;
  }
}
</style>
